module.exports = __webpack_public_path__ + "static/media/tabbe.265739e0.mp3";